import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-matprogressbar',
	templateUrl:'./MatProgressBarPage.html',
	styles: [],
	styleUrls:['./MatProgressBarPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatProgressBarPage
{
	mdContent_260 = `\`\`\`java
import com.jwebmp.plugins.angular.material.progressbar.MatProgressBar;
\`\`\``;
	mdContent_261 = `\`\`\`java
MatProgressBar()
\`\`\``;
	mdContent_262 = `\`\`\`java
MatProgressBar&lt;?&gt; bar = new MatProgressBar&lt;&gt;();
bar.setMode("indeterminate");
bar.setColor("accent");
\`\`\``;
}
